import {
  SendTargetType,
  SendTo,
  TeamDisplayData,
  TenantMemberDisplayData,
  TenantMemberOrTeamDisplayData,
} from '@kudos/http-client'
import { isTenantMemberDisplayData } from '@shared/avatar/useAvatarConfig'
import { fullNameFromParts } from './nameFormatting'

export const getSendToFromTenantMemberAndTeams = (
  recipients: TenantMemberOrTeamDisplayData[],
): SendTo[] => {
  return recipients.map(recipient => {
    const isTenantMember = isTenantMemberDisplayData(recipient)
    const fullName =
      isTenantMember &&
      fullNameFromParts(
        (recipient as TenantMemberDisplayData).firstName,
        (recipient as TenantMemberDisplayData).lastName,
      )
    return {
      id: recipient.id,
      name: isTenantMember ? fullName : (recipient as TeamDisplayData).name,
      type: isTenantMember ? SendTargetType.TENANT_MEMBER : SendTargetType.TEAM,
    } as SendTo
  })
}
